import { DataSource, CollectionViewer } from "@angular/cdk/collections";
import { CdkVirtualForOf } from "@angular/cdk/scrolling";
import { BehaviorSubject, Subscription, Observable } from "rxjs";
import { Config } from "src/infrastructure/config";
import { ProductSearchFilter } from "src/models/DTO/filters/productSearchFilter";
import { ProductCollectionItem } from "src/models/DTO/products/productCollectionItem";
import { ImagesService } from "src/services/request/images/images.service";
import { ProductsService } from "src/services/request/products/products.service";
import { RatingsService } from "src/services/request/ratings/ratings.service";

export class AllProductDataSourceInTwo extends DataSource<ProductCollectionItem[] | undefined> {
    private _length = Config.defaultItemsPerPage;
    private _productsLength = 0;
    private _lastPage: number = -1;
    private _filters: ProductSearchFilter;
    private _query: string;
    private _sorter: string;
    private _pageSize = Config.defaultItemsPerPage;
    private _cachedData: (ProductCollectionItem[] | undefined)[]
    private _fetchedPages = new Set<number>();
    private readonly _dataStream;
    private readonly _subscription = new Subscription();
    private _loading = false;
    private virtualScroll?: any;

    constructor(
      private ratingService: RatingsService,
      private productsService: ProductsService,
      private imagesService: ImagesService,
      lastPage: number,
      query: string,
      sorter: string,
      filters: ProductSearchFilter,
      pageSize: number) {
      super();
      this._lastPage = lastPage;
      this._filters = filters;
      this._query = query;
      this._sorter = sorter;
      this._pageSize = pageSize;
      this._length = pageSize;
      this._cachedData = Array.from<ProductCollectionItem[] | undefined>({length: this._length});;
      this._dataStream = new BehaviorSubject<(ProductCollectionItem[] | undefined)[]>(this._cachedData);

    }

    connect(collectionViewer: CollectionViewer): Observable<(ProductCollectionItem[] | undefined)[]> {
      this.virtualScroll = collectionViewer;
      this._subscription.add(
        collectionViewer.viewChange.subscribe(range => {
          const startPage = this._getPageForIndex(range.start);
          const endPage = this._getPageForIndex(range.end - 1);
          for (let i = startPage; i <= endPage; i++) {
            this._fetchPage(i);
          }
        }),
      );
      return this._dataStream;
    }
  
    disconnect(): void {
      this._subscription.unsubscribe();
    }

    get productsLength() {
      return this._productsLength;
    }

    get loading() {
      return this._loading;
    }
  
    private _getPageForIndex(index: number): number {
      return Math.floor(index / this._pageSize);
    }
  
    private _fetchPage(pageToLoad: number) {
      const page = pageToLoad;
      const pageFromServer = pageToLoad + 1; 
      if (this._fetchedPages.has(page)) {
        return;
      }
      if (this._lastPage < pageFromServer) {
        return;
      }
      this._fetchedPages.add(page);
      this._loading = true;
      this.productsService.getAllProductsPerSearch(this._pageSize, pageFromServer, this._query, this._sorter, this._filters).subscribe(products => {
        this._productsLength += products.data.length;
        this._loading = false
        products.data.forEach(product => {
          product.imageURL = '';
          this.imagesService.getImagesForProduct("PRODUCT", product.uuid).subscribe(images => {
            product.imageURL = images.data[0].original.url
          })
          product.ratings = { data: []}
          this.getRatingsForProduct(product);
        })
        if (products.data.length) {
          const chunkSize = 2;
          let array: Array<ProductCollectionItem[]> = [];
          for (let i = 0; i < products.data.length; i += chunkSize) {
              const chunk = products.data.slice(i, i + chunkSize);
              array.push(chunk);
          }
          this._cachedData.splice(
            page * this._pageSize,
            this._pageSize,
            ...array
          );
        } 
        this._dataStream.next(this._cachedData);
        this.virtualScroll!._viewport.checkViewportSize()
      })
    }

    private getRatingsForProduct(product: ProductCollectionItem) {
      this.ratingService.getRatingsPerProduct(product.uuid).subscribe(ratings => {
          product.ratings = ratings;
          this.getRatingsAvg(product)
      })
    }
  
    private getRatingsAvg(product: ProductCollectionItem) {
      let ratingsScore = 0;
      const ratingsCount = product.ratings?.data.length || 0;
      product.ratings?.data.forEach(rating => {
        ratingsScore += rating.rating
      })
      product.ratingAvgValue = ratingsScore / ratingsCount;
    }

  }